import { render } from "./ResidentControl.vue?vue&type=template&id=697007a9&scoped=true"
import script from "./ResidentControl.vue?vue&type=script&lang=js"
export * from "./ResidentControl.vue?vue&type=script&lang=js"

import "./ResidentControl.vue?vue&type=style&index=0&id=697007a9&scoped=true&lang=css"

import exportComponent from "E:\\changjuCode\\official-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-697007a9"]])

export default __exports__